export const POST_SIGN_IN_PENDING = "POST_SIGN_IN_PENDING";
export const POST_SIGN_IN = "POST_SIGN_IN";
export const UPDATE_USER_ID = "UPDATE_USER_ID";
export const POST_SIGN_IN_SUCCESS_USER = "POST_SIGN_IN_SUCCESS_USER";
export const POST_SIGN_IN_SUCCESS_ADMIN = "POST_SIGN_IN_SUCCESS_ADMIN";
export const POST_SIGN_IN_FAILURE = "POST_SIGN_IN_FAILURE";
export const SIGN_OUT = "SIGN_OUT";
export const SIGN_OUT_SUCCESS = "SIGN_OUT_SUCCESS";
export const SIGN_OUT_FAILURE = "SIGN_OUT_FAILURE";
export const TOKEN_REFRESH = "TOKEN_REFRESH";
export const TOKEN_AUTH_ERROR = "TOKEN_AUTH_ERROR";
export const CHECK_AUTHORIZATION = "CHECK_AUTHORIZATION";
